"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Component = function (_a) {
    var html = _a.html;
    if (!html) {
        return null;
    }
    return React.createElement("div", { dangerouslySetInnerHTML: { __html: html } });
};
var HTML = {
    name: "global:html",
    label: "Egendefinert HTML",
    description: "Legg inn egendefinert HTML/CSS",
    reactComponent: Component,
    icon: "code",
    usableInRichContent: true,
    usableInSection: true,
    props: [
        {
            name: "html",
            label: "HTML",
            type: "html",
        },
    ],
};
exports.default = HTML;
//# sourceMappingURL=index.js.map